<template>
  <div :style="me.data.id === history.sender_id ? 'text-align: -webkit-right; text-align: right;' :
               'text-align: -webkit-right; text-align: left;'">

    <div :class="me.data.id === history.sender_id ? 'operator' :
                 'lead'"
         class="balloon px-3"
         @mouseover.prevent="previewChevron(history.id)"
         @mouseleave.prevent="previewChevron(null)">

      <!--REPLY CONTENT PREVIEW-->
      <div v-if="history.conversation_id !== null"
           class="pt-1 pb-2">
        <div class="d-flex my-0"
             :class="me.data.id === history.sender_id ? 'callout-ballon-operator' : 'callout-primary'"
             :style="me.data.id === history.sender_id ? 'background: rgb(100 169 128 / 10%)' :
                     'background: rgb(0 0 0 / 7%)'"
             style="border-radius: 8px;
                  font-size: 12px;
                  padding: 10px;">
          <div class="pl-1 cursor_default pr-3 w-100">
            <div class="row">
              <div class="col-12 pt-3 pb-0 text-left">
                <strong :class="me.data.id === history.sender_id ? 'text-callout-ballon-operator' :
                               'text-callout-primary'">
                  {{ operator_name(history) }}
                </strong>
              </div>
            </div>
            <div class="row">
              <div class="col-12 pt-1 pb-3 cursor_default text-left">
                <i v-if="['image/png', 'image/jpeg', 'image/jpg', 'image/webp'].includes(history.reply_mime_type_file)" class="bx bxs-camera pr-1"></i>
                <i v-else-if="['application/pdf'].includes(history.reply_mime_type_file)" class="bx bxs-file-pdf pr-1"></i>
                <i v-else-if="['video/mpeg', 'video/mp4'].includes(history.reply_mime_type_file)" class="bx bxs-camera-movie pr-1"></i>
                <i v-else-if="['audio/mp3', 'audio/mp4', 'audio/ogg', 'audio/x-m4a', 'audio/mpeg', 'video/webm', 'audio/x-aac', 'audio/x-wav'].includes(history.reply_mime_type_file)" class="bx bxs-microphone pr-1"></i>
                <i v-else-if="['application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/msword'].includes(history.reply_mime_type_file)" class="fa fa-file-word pr-1"></i>
                <i v-else-if="['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'].includes(history.reply_mime_type_file)" class="fa fa-file-excel pr-1"></i>
                <i v-else-if="['dropbox'].includes(history.reply_mime_type_file)" class="bx bx-cloud-download pr-1"></i>
                <i v-else-if="history.reply_url_file" class="bx bx-file pr-1"></i>
                <i v-else-if="lengthSplitTextHistoryPipe(history.reply_text) > 1 && getSplitTypeTextHistoryPipe(history.reply_text) === 'location'" class="bx bxs-map pr-1"></i>
                <i v-else-if="lengthSplitTextHistoryPipe(history.reply_text) > 1 && getSplitTypeTextHistoryPipe(history.reply_text) === 'vcard'" class="bx bxs-user pr-1"></i>
                <span v-b-tooltip.bottom
                      v-if="lengthSplitTextHistoryPipe(history.reply_text) > 1 && getSplitTypeTextHistoryPipe(history.reply_text) === 'location'"
                      :title="getSplitTextHistoryPipe(history.reply_text).address">
                  {{ (getSplitTextHistoryPipe(history.reply_text).address ? getSplitTextHistoryPipe(history.reply_text).address : getTranslations('expression_866')) | truncate(30) }}
                </span>
                <span v-b-tooltip.bottom
                      v-else-if="lengthSplitTextHistoryPipe(history.reply_text) > 1 && getSplitTypeTextHistoryPipe(history.reply_text) === 'vcard'"
                      :title="getSplitTextHistoryPipe(history.reply_text).address">
                  {{ (getSplitTextHistoryPipe(history.reply_text).name ? getSplitTextHistoryPipe(history.reply_text).name : getTranslations('expression_866')) | truncate(30) }}
                </span>
                <span v-else v-b-tooltip.bottom
                      :title="history.reply_text">
                  {{ (history.reply_text ? history.reply_text : getTranslations('expression_866')) | truncate(30) }}
                </span>
              </div>
            </div>
          </div>
          <div v-if="history.reply_url_file">
            <!-- GENERIC FILES -->
            <div style="max-height: 50px;
                              min-height: 50px;
                              min-width: 50px;
                              max-width: 50px;
                              margin-top: 0;
                              display: flex;
                              border-radius: 8px;
                              align-items: center;
                              justify-content: center;"
                 class="bg-light  cursor_pointer reply-img"
                 @click.prevent="openUrl(history.reply_url_file)">
              <i class="bx bx-file bx-sm text-gray-700"></i>
            </div>

          </div>
        </div>
      </div>

      <!--CONTENT FILE TYPES-->
      <div class="pb-2"
           style="display: flex;
                  justify-content: center;">
        <!-- GENERIC FILES -->
        <div v-if="history.file"
             style="max-height: 120px;
                    min-height: 120px;
                    min-width: 100%;
                    max-width: 120px;
                    width: 100%;
                    margin-top: .5rem;
                    display: flex;
                    border-radius: 10px;
                    align-items: center;
                    justify-content: center;"
             class="bg-light shadow-sm cursor_pointer pb-1"
             @click.prevent="openUrl(history.url_file)">
          <i class="bx bx-file bx-md text-gray-700"></i>
        </div>
      </div>

      <!-- TEXT -->
      <div class="pb-1 pt-1"
           style="overflow:hidden;
                  word-wrap: break-word;
                  white-space: pre-wrap;"
           v-html="history.text"
           v-if="lengthSplitTextHistoryPipe(history.text) === 1">
      </div>

      <!--Responder REMETENTE-->
      <div v-if="`chevron_${history.id}` === hover_id && me.data.id === history.sender_id"
           style="margin-block: 5px;"
           v-b-tooltip.top
           :title="getTranslations('expression_1097')"
           @click.prevent="setReply(history)"
           class="float-left pr-3 cursor_pointer d-flex">
        <i class="bx bxs-share pr-2"></i>
      </div>

      <!--Horário-->
      <div :class="me.data.id === history.sender_id ? 'time-right' :
                   'time-left'"
           style="color: #8696a0;"
           class="timer">
        {{ history.created }}
      </div>

      <!--Responder DESTINATARIO-->
      <div v-if="`chevron_${history.id}` === hover_id &&  me.data.id !== history.sender_id"
           style="margin-block: 5px;"
           @click.prevent="setReply(history)"
           v-b-tooltip.top
           :title="getTranslations('expression_1097')"
           class="float-right pl-3 cursor_pointer d-flex">
        <i class="bx bxs-share pr-2"></i>
      </div>
    </div>
  </div>
</template>

<script>
import lead_avatar from "../../assets/img/no-pic-user.png";
import {mapGetters, mapState} from "vuex";
export default {
  name: "ChatBalloonConversation",

  data() {
    return {
      lead_avatar: lead_avatar,
      hover_id: null
    }
  },
  props: [
    'history',
    'show_reply',
  ],
  computed: {
    ...mapState(['chat', 'configs', 'conversations']),
  },
  methods: {
    //TODO: Payload (conversations.chat) não é um Array - Ajustar no backend
    operator_name(payload){
        const conversation = this.conversations.chat.find(item => {
          return item.id === payload.conversation_id
        })
        return this.me.data.id === conversation.sender_id ? this.getTranslations('expression_1096') : this.getUserObject('id', conversation.sender_id).name
     },
    openUrl(payload) {
      window.open(payload, "_blank");
    },
    setMedia(payload) {
      this.chat.show_media = this.xeroxHelper(payload)
    },
    previewChevron(payload) {
      this.hover_id = payload ? `chevron_${payload}` : null;
    },
    setReply(payload){
      this.conversations.reply = this.xeroxHelper(payload)
      this.downScrollChat()
    },
    lengthSplitTextHistoryPipe(payload) {
      return payload ? payload.split("|").length : 0
    },
    getSplitTypeTextHistoryPipe(payload) {
      return payload ? payload.split("|")[0] : null
    },
    getSplitTextHistoryPipe(payload) {
      return payload && payload.split("|").slice(1) !== undefined ? JSON.parse(payload.split("|").slice(1)) : {}
    },
  }

}
</script>
<style scoped>
.balloon{
  min-width: 205px!important;
  border-radius: 15px 15px 15px 0!important;
  padding: 12px 20px!important;;
  margin: 10px 0;
  word-break: break-word;
}
.balloon.operator {
  /*border: 0;*/
  border: 0;
  border: 1px solid #c7e9c3;
  /*background-color: #38b5aa;*/
  /*background-color: #36aecc;*/
  background-color: #daf2f8;
  border-radius: 15px 15px 0 15px !important;
}
.controlBar {
  background-color: transparent!important;
}
.system, .api{
  border-radius: 20px!important;
  width: 100%;
  min-width: 100%!important;
  text-align: left;
  background-color: #ffffff!important;
 
}
.lead{

}
.api {

}
.time-system {
  float: right;
  color: #7b7b7b;
}

.reply-img {
  width: 50px;
  height: 50px;
  display: flex;
  border-radius: 8px;
  align-items: center;
  justify-content: center;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover!important;
  background-color: #eee;
}

</style>

<style src="../../assets/css/pages/chat.css" scoped/>
